/** @jsxImportSource @emotion/react */
import * as React from "react";
import { css, SerializedStyles } from "@emotion/react";
import { LargeText } from "../../styles/styles";

/**
 * LabeledData: a component that shows form data next to a label (e.g. Guest: Bob Schmo)
 * There's no great name for this thing, but it shows big, taking up a row like a form input.
 *
 * PureComponent: true
 * Connected to Redux: false
 */
export default class LabeledData extends React.PureComponent<{
  label: string;
  data: string | number;
  title?: string;
  rootCss?: SerializedStyles;
  labelCss?: SerializedStyles;
}> {
  public render = () => (
    <span
      title={this.props.title}
      css={css`
        display: flex;
        align-items: baseline;
        gap: 0.5rem;
        ${LargeText};
        ${this.props.rootCss};
      `}
    >
      <span
        css={css`
          font-weight: bold;
          ${LargeText};
          ${this.props.labelCss};
        `}
      >
        {this.props.label}
      </span>{" "}
      {this.props.data}
    </span>
  );
}
